/**
 * Determines if a company is eligible for the reduced website scrape price (99 €).
 *
 * Eligibility conditions (any one is sufficient):
 * 1. The company has previously bought a 5-list bundle (`bought5Lists`)
 * 2. The company has an annual subscription (`perMonthOrYear === "YEAR"`)
 * 3. The company has a bi-annual/semi-annual subscription (`perMonthOrYear === "HALF_YEAR"`)
 */
export const isEligibleForReducedWebsiteScrapePrice = ({
	bought5Lists,
	perMonthOrYear,
}: {
	bought5Lists?: boolean;
	perMonthOrYear?: string;
}): boolean => {
	const hasAnnualOrSemiAnnual = perMonthOrYear === "YEAR" || perMonthOrYear === "HALF_YEAR";

	return Boolean(bought5Lists) || hasAnnualOrSemiAnnual;
};
